/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ProductPageService";
const log: any = LoggerModule.getInstance();

export class ProductPageService {
  private static instance: ProductPageService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ProductPageService {
    if (!ProductPageService.instance) {
      ProductPageService.instance = new ProductPageService(props);
    }
    return ProductPageService.instance;
  }

  public async getHeaderNavItems() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent.getHeaderNavContent({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(`content in Header service`, compProps);
    return content;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Feature Section Props
    compProps = await agent.getFeatureSectionProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Footer Props
    compProps = await agent.getFooterProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
